import React from 'react';

const font = "'DM Sans', sans-serif";
const C = { turquesa:'#5dc1b9', mango:'#FDBE02', coral:'#eb636b', logoGrad:'linear-gradient(135deg, #534AB7, #1D9E75)' };

// Genio & Luca hint card — shows first 3 visits, then disappears
export function GenioLucaHint({ userId, t }) {
  const key = 'td_gl_hint_' + (userId || '');
  const count = parseInt(localStorage.getItem(key) || '0');
  if (count >= 3) return null;

  // Increment on mount
  React.useEffect(() => {
    localStorage.setItem(key, String(count + 1));
  }, [key, count]);

  return (
    <div style={{
      background: `linear-gradient(135deg, ${C.turquesa}08, ${C.mango}06, ${C.coral}08)`,
      border: `0.5px solid ${C.turquesa}20`, borderRadius: 20, padding: '16px 20px',
      marginBottom: '2.5rem', display: 'flex', alignItems: 'center', gap: 14, flexWrap: 'wrap',
    }}>
      <div style={{ display: 'flex', gap: 6 }}>
        <div style={{ width: 32, height: 32, borderRadius: '50%', background: `linear-gradient(135deg, ${C.mango}, ${C.coral})`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14 }}>⚡</div>
        <div style={{ width: 32, height: 32, borderRadius: '50%', background: `linear-gradient(135deg, ${C.turquesa}, ${C.mango})`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14 }}>◆</div>
      </div>
      <div style={{ flex: 1, minWidth: 180 }}>
        <p style={{ fontSize: 14, fontWeight: 500, margin: '0 0 2px' }}>Genio & Luca están listos para ayudarte</p>
        <p style={{ fontSize: 12, color: t.textSecondary, margin: 0 }}>Toca la neurona ⚡◆ en la esquina para hablar con ellos →</p>
      </div>
    </div>
  );
}

// Placeholder sales for empty state
export function PlaceholderSales({ t }) {
  const items = [
    { product: 'Ejemplo: Producto A', price: 350, channel: 'store' },
    { product: 'Ejemplo: Producto B', price: 580, channel: 'online' },
  ];
  return (
    <div style={{ opacity: 0.7 }}>
      <span style={{ display:'inline-block', fontSize:11, padding:'2px 10px', borderRadius:10, background:t.isDark?'#333':'#eee', color:t.textSecondary, marginBottom:8 }}>📋 Ejemplo</span>
      {items.map((s, i) => (
        <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '6px 0', borderBottom: `1px dashed ${t.border}` }}>
          <span>{s.channel === 'store' ? '🏪' : '📱'}</span>
          <span style={{ flex: 1, fontSize: 13 }}>{s.product}</span>
          <span style={{ fontSize: 13, fontWeight: 500 }}>${s.price}</span>
        </div>
      ))}
    </div>
  );
}

// Placeholder tasks
export function PlaceholderTasks({ t }) {
  return (
    <div style={{ opacity: 0.7 }}>
      <span style={{ display:'inline-block', fontSize:11, padding:'2px 10px', borderRadius:10, background:t.isDark?'#333':'#eee', color:t.textSecondary, marginBottom:8 }}>📋 Ejemplo</span>
      {['Ejemplo: Responder comentarios', 'Ejemplo: Subir contenido semanal'].map((t2, i) => (
        <div key={i} style={{ background: t.card, border: `1.5px dashed ${t.border}`, borderRadius: 20, padding: '12px 16px', marginBottom: 8, display: 'flex', alignItems: 'center', gap: 12 }}>
          <div style={{ width: 20, height: 20, borderRadius: 6, border: `2px solid ${t.border}` }} />
          <span style={{ fontSize: 13 }}>{t2}</span>
        </div>
      ))}
    </div>
  );
}

// Placeholder donut
export function PlaceholderDonut({ t }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '1.25rem' }}>
      <div style={{ width: 140, height: 140, borderRadius: '50%', background: t.isDark ? '#333' : '#f0f0ed', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ width: 90, height: 90, borderRadius: '50%', background: t.card, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
          <span style={{ fontSize: 16, color: t.textSecondary }}>—%</span>
          <span style={{ fontSize: 10, color: t.textSecondary }}>digital</span>
        </div>
      </div>
      <p style={{ fontSize: 12, color: t.textSecondary, margin: '12px 0 0', textAlign: 'center' }}>Tu gráfica aparecerá aquí</p>
    </div>
  );
}

// Placeholder bars
export function PlaceholderBars({ t }) {
  return (
    <div style={{ padding: '1.25rem' }}>
      <p style={{ fontSize: 13, fontWeight: 500, margin: '0 0 14px' }}>Últimos 6 meses</p>
      <div style={{ display: 'flex', alignItems: 'flex-end', gap: 10, height: 120, opacity: 0.3 }}>
        {['E', 'F', 'M', 'A', 'M', 'J'].map((m, i) => (
          <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
            <div style={{ width: '100%', height: `${15 + i * 5}%`, background: t.isDark ? '#444' : '#ddd', borderRadius: '4px 4px 0 0' }} />
            <span style={{ fontSize: 10, color: t.textSecondary }}>{m}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
